module.exports = __webpack_public_path__ + "fb9cc18c0817905175b01de9d8f27e0b.jpg";